<template>
  <div class="w">
    <y-shelf title="支付成功" style="text-align: center">
      <div slot="content" class="content">
        <p><i class="el-icon-circle-check icon-success"></i> 恭喜您支付成功
        <div style="margin-top: 20px;">
          <router-link to="/user">
            <y-button text="查看订单" style="width: 150px;height: 50px;line-height: 48px;font-size: 20px"
                      classStyle="main-btn"></y-button>

          </router-link>
          <router-link to="/goods">
            <y-button text="继续选购" style="width: 150px;height: 50px;line-height: 48px;font-size: 20px"
                      classStyle="main-btn"></y-button>

          </router-link>
        </div>
      </div>
    </y-shelf>
  </div>
</template>
<script>
  import YShelf from '@/components/shelf'
  import YButton from '@/components/yButton'
  export default {
    data () {
      return {
        price: 10
      }
    },
    components: {
      YShelf,
      YButton
    },
    created () {
      this.price = this.$route.query.price
    }
  }
</script>
<style lang="stylus" scoped>
  .content {
    padding: 150px 0;
    font-size: 30px;
  }

  .icon-success {
    font-size: 33px;
    color: #01b401;
  }

  span.price {
    color: #d44d44;
    font-weight: 700;
    line-height: 20px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// paysuccess.vue?8d56cfe0